var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 351.417,
    height: 153.5,
    viewBox: "0 0 351.417 153.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2",
    transform: "translate(0.001 0)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laag_1",
    "data-name": "Laag 1",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(69.686 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M78.07,3.267A3.276,3.276,0,1,0,81.337,0,3.276,3.276,0,0,0,78.07,3.267",
    transform: "translate(-78.07 0)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(103.042 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    d: "M115.44,3.267A3.276,3.276,0,1,0,118.707,0a3.276,3.276,0,0,0-3.267,3.267",
    transform: "translate(-115.44 0)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(138.487 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    d: "M155.15,3.267A3.267,3.267,0,1,0,158.417,0a3.267,3.267,0,0,0-3.267,3.267",
    transform: "translate(-155.15 0)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(171.844 0)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    d: "M192.52,3.267A3.267,3.267,0,1,0,195.787,0a3.267,3.267,0,0,0-3.267,3.267",
    transform: "translate(-192.52 0)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(206.387 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    d: "M231.22,3.267A3.267,3.267,0,1,0,234.487,0a3.267,3.267,0,0,0-3.267,3.267",
    transform: "translate(-231.22 0)",
    fill: "#356bb0",
    fillRule: "evenodd",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(241.529 0)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    d: "M270.59,3.267A3.267,3.267,0,1,0,273.857,0a3.267,3.267,0,0,0-3.267,3.267",
    transform: "translate(-270.59 0)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(275.18 0)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    d: "M308.29,3.267a3.289,3.289,0,1,1,.045,0",
    transform: "translate(-308.29)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(310.321 0)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-28",
    d: "M347.66,3.267A3.267,3.267,0,1,0,350.927,0a3.267,3.267,0,0,0-3.267,3.267",
    transform: "translate(-347.66 0)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(0 29.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-34",
    d: "M0,36.667a3.2,3.2,0,0,0,3.115,3.267,3.267,3.267,0,1,0,0-6.534A3.2,3.2,0,0,0,0,36.667",
    transform: "translate(0.001 -33.4)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-37",
    d: "M39,36.1a3.11,3.11,0,1,1,0,.027",
    transform: "translate(-4.188 -3.544)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-39",
    d: "M78,36.1a3.111,3.111,0,1,1,0,.027",
    transform: "translate(-8.376 -3.544)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-41",
    d: "M115,36.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,115,36.094",
    transform: "translate(-12.35 -3.541)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-43",
    d: "M155,36.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,155,36.094",
    transform: "translate(-16.646 -3.541)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-45",
    d: "M193,36.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,193,36.094",
    transform: "translate(-20.728 -3.541)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-47",
    d: "M232,36.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,232,36.094",
    transform: "translate(-24.916 -3.541)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-49",
    d: "M271,36.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,271,36.094",
    transform: "translate(-29.105 -3.541)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-51",
    d: "M309,36.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,309,36.094",
    transform: "translate(-33.187 -3.541)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-53",
    d: "M348,36.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,348,36.094",
    transform: "translate(-37.375 -3.541)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-57",
    transform: "translate(344.838 29.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-55",
    d: "M386.357,36.667a1.35,1.35,0,1,0-.027,0",
    transform: "translate(-386.33 -33.4)",
    fill: "#356bb0",
    fillRule: "evenodd",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-61",
    d: "M39,69.1a3.111,3.111,0,1,1,0,.027",
    transform: "translate(-4.188 -7.088)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-63",
    d: "M78,69.1a3.111,3.111,0,1,1,0,.027",
    transform: "translate(-8.376 -7.088)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-65",
    d: "M115,69.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,115,69.094",
    transform: "translate(-12.35 -7.085)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-67",
    d: "M155,69.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,155,69.094",
    transform: "translate(-16.646 -7.085)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-69",
    d: "M193,69.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,193,69.094",
    transform: "translate(-20.728 -7.085)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-71",
    d: "M232,69.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,232,69.094",
    transform: "translate(-24.916 -7.085)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-73",
    d: "M271,69.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,271,69.094",
    transform: "translate(-29.105 -7.085)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-75",
    d: "M309,69.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,309,69.094",
    transform: "translate(-33.187 -7.085)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-77",
    d: "M348,69.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,348,69.094",
    transform: "translate(-37.375 -7.085)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-81",
    transform: "translate(344.838 59.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-79",
    d: "M386.357,69.4a1.35,1.35,0,1,0-.027,0",
    transform: "translate(-386.33 -66.13)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-84",
    transform: "translate(0 87.939)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-82",
    d: "M0,101.8a3.2,3.2,0,0,0,3.115,3.267,3.276,3.276,0,0,0,0-6.543A3.2,3.2,0,0,0,0,101.8",
    transform: "translate(0.001 -98.52)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-85",
    d: "M39,102.1a3.111,3.111,0,1,1,0,.027",
    transform: "translate(-4.188 -10.633)",
    fill: "#356bb0",
    fillRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-87",
    d: "M78,102.1a3.111,3.111,0,1,1,0,.027",
    transform: "translate(-8.376 -10.633)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-89",
    d: "M115,102.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,115,102.094",
    transform: "translate(-12.35 -10.63)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-91",
    d: "M155,102.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,155,102.094",
    transform: "translate(-16.646 -10.63)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-93",
    d: "M193,102.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,193,102.094",
    transform: "translate(-20.728 -10.63)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-95",
    d: "M232,102.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,232,102.094",
    transform: "translate(-24.916 -10.63)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-97",
    d: "M271,102.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,271,102.094",
    transform: "translate(-29.105 -10.63)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-99",
    d: "M309,102.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,309,102.094",
    transform: "translate(-33.187 -10.63)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-101",
    d: "M348,102.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,348,102.094",
    transform: "translate(-37.375 -10.63)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-105",
    transform: "translate(344.838 87.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-103",
    d: "M386.357,101.8a1.351,1.351,0,1,0-.027,0",
    transform: "translate(-386.33 -98.52)",
    fill: "#356bb0",
    fillRule: "evenodd",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-109",
    d: "M39,135.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,39,135.094",
    transform: "translate(-4.188 -14.174)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-111",
    d: "M78,135.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,78,135.094",
    transform: "translate(-8.376 -14.174)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-113",
    d: "M115,135.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,115,135.094",
    transform: "translate(-12.35 -14.174)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-115",
    d: "M155,135.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,155,135.094",
    transform: "translate(-16.646 -14.174)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-117",
    d: "M193,135.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,193,135.094",
    transform: "translate(-20.728 -14.174)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-119",
    d: "M232,135.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,232,135.094",
    transform: "translate(-24.916 -14.174)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-121",
    d: "M271,135.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,271,135.094",
    transform: "translate(-29.105 -14.174)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-123",
    d: "M309,135.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,309,135.094",
    transform: "translate(-33.187 -14.174)",
    fill: "#356bb0",
    fillRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-125",
    d: "M348,135.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,348,135.094",
    transform: "translate(-37.375 -14.174)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-129",
    transform: "translate(344.865 117.153)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-127",
    d: "M386.36,134.526a3.267,3.267,0,1,0,.957-2.319,3.276,3.276,0,0,0-.957,2.319",
    transform: "translate(-386.36 -131.25)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-133",
    d: "M39,168.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,39,168.094",
    transform: "translate(-4.188 -17.718)",
    fill: "#356bb0",
    fillRule: "evenodd",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-135",
    d: "M78,168.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,78,168.094",
    transform: "translate(-8.376 -17.718)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-137",
    d: "M115,168.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,115,168.094",
    transform: "translate(-12.35 -17.718)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-139",
    d: "M155,168.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,155,168.094",
    transform: "translate(-16.646 -17.718)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-141",
    d: "M193,168.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,193,168.094",
    transform: "translate(-20.728 -17.718)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-143",
    d: "M232,168.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,232,168.094",
    transform: "translate(-24.916 -17.718)",
    fill: "#356bb0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-145",
    d: "M271,168.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,271,168.094",
    transform: "translate(-29.105 -17.718)",
    fill: "#356bb0",
    fillRule: "evenodd",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-147",
    d: "M309,168.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,309,168.094",
    transform: "translate(-33.187 -17.718)",
    fill: "#356bb0",
    fillRule: "evenodd",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-149",
    d: "M348,168.094a3.124,3.124,0,1,0,3.124-3.124A3.124,3.124,0,0,0,348,168.094",
    transform: "translate(-37.375 -17.718)",
    fill: "#356bb0",
    fillRule: "evenodd",
    opacity: 0.1
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDots);
export default __webpack_public_path__ + "static/media/bg-dots.14ef6ae3680617a2c26791ce46384a06.svg";
export { ForwardRef as ReactComponent };